import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "lc_radius",
  "use": "lc_radius-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"lc_radius\"><path d=\"M832 1024h-128v-128h128a64 64 0 0 0 64-64v-128h128v128a192 192 0 0 1-192 192z m-512 0H192a192 192 0 0 1-192-192v-128h128v128a64 64 0 0 0 64 64h128v128zM1024 320h-128V192a64 64 0 0 0-64-64h-128V0h128a192 192 0 0 1 192 192v128zM128 320H0V192a192 192 0 0 1 192-192h128v128H192a64 64 0 0 0-64 64v128z\" fill=\"#707070\" p-id=\"9778\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol